// Support, as a platform module. Its address comes from support-path.js and is never
// retyped here: moving Support again stays a change to SUPPORT_BASE alone.
import { SUPPORT_BASE, supportPath } from '../support-path.js';
// EAGER, unlike every other module (R12, R14): Support's entry is imported here, so it
// ships in the shell's own bundle and `load` resolves at once. Support is the module
// every user opens first, and production enables Support alone; master shipped one
// bundle, and a browser extension in the owner's Chrome stalled the lazy Support chunk
// forever, leaving "Loading Support…" with no way out. The spec's "the entry is loaded
// on first open" records this as its one deviation (The entry). Other modules stay
// lazy, behind ModuleHost's 15 s deadline.
import entry from './entry.jsx';

export default {
  id: 'support',
  label: 'Support',
  product: 'support',
  order: 1,
  basePath: SUPPORT_BASE,
  home: supportPath('/tickets'),
  load: () => Promise.resolve({ default: entry }),
};
